export const maxIbanLength = 5;
